import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isOffline, user } = useAuth();
  const location = useLocation();

  // Store the last online route in session storage for recovery
  useEffect(() => {
    if (
      !isOffline &&
      !location.pathname.includes('/login') &&
      !location.pathname.includes('/offline') &&
      !location.pathname.includes('/public')
    ) {
      sessionStorage.setItem('lastOnlineRoute', location.pathname);
    }
  }, [isOffline, location.pathname]);

  // Public routes that don't require authentication
  const publicRoutes = ['/public', '/login', '/offline'];

  // Check if current path is a public route
  const isPublicRoute = publicRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  // If route is public, allow access without authentication
  if (isPublicRoute && !isAuthenticated) {
    return children;
  }

  // For all other routes, require authentication
  if (!isAuthenticated) {
    // If offline, redirect to offline page
    if (isOffline) {
      return <Navigate to="/offline" replace />;
    }

    // Otherwise redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, allow access to the route
  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProtectedRoute;
